import Vue from 'vue'
import Vuex from 'vuex'

import { Module, createStore } from 'vuex-smart-module'

// Modules
import { mobileWidth } from '@/store/modules/mobileWidth'
import { toast } from '@/store/modules/toast'
import { user } from '@/store/modules/user'
import { importLog } from '@/store/modules/importLog'
import { dicts } from '@/store/modules/dicts'
import { publicationEdit } from '@/store/modules/publicationEdit'
import { loading } from '@/store/modules/loading'
import { navBarTitle } from '@/store/modules/navbar'
import { notifications } from '@/store/modules/notifications'
import { affiliations } from '@/store/modules/affiliations'
import { ctt } from './modules/ctt'

Vue.use(Vuex)

const root = new Module({
  modules: {
    mobileWidth,
    toast,
    user,
    dicts,
    importLog,
    publicationEdit,
    loading,
    navBarTitle,
    notifications,
    affiliations,
    ctt
  }
})

export default createStore(root)
